require('./ck_editor_config');



// WEBPACK FOOTER //
// ./app/lib/constants/main.ts